import { createApiInstance } from './apiClient'
import { ENV_URLS } from '../../helpers/Constants'

export const httpBase = (patch, download) =>
  createApiInstance({
    baseURL: `${ENV_URLS.URL}/${ENV_URLS.API}/`,
    headers: {},
    patch,
    download,
  })

export const externalHttpCIBase = (customerId) =>
  createApiInstance({
    baseURL: `${ENV_URLS.SERVICE_CI_URL}/${ENV_URLS.API}/`,
    headers: { CustomerId: customerId },
  })

export const externalHttpCACBase = (customerId) =>
  createApiInstance({
    baseURL: `${ENV_URLS.SERVICE_CAC_URL}/${ENV_URLS.API}/`,
    headers: { CustomerId: customerId },
  })

export const externalHttpCoreViewBase = (customerId, patch) =>
  createApiInstance({
    baseURL: `${ENV_URLS.SERVICE_COREVIEW_URL}/${ENV_URLS.API}/`,
    headers: { CustomerId: customerId },
    patch,
  })

export const externalHttpCoreViewBaseWebPortal = (customerId, patch) =>
  createApiInstance({
    baseURL: `${ENV_URLS.URL}/${ENV_URLS.API}/`,
    headers: { CustomerId: customerId },
    patch,
  })

export const externalHttpMAXCSBase = (customerId, patch) =>
  createApiInstance({
    baseURL: `${ENV_URLS.SERVICE_MAXCS_URL}/${ENV_URLS.API}/`,
    headers: { CustomerId: customerId },
    patch,
  })

export const externalHttpDIRECTROUTINGBase = (customerId, patch) =>
  createApiInstance({
    baseURL: `${ENV_URLS.SERVICE_DIRECTROUTING_URL}/${ENV_URLS.API}/`,
    headers: { CustomerId: customerId },
    patch,
  })

export const externalHttpDIRECTROUTINGBaseGet = (customerId, productCode, patch) =>
  createApiInstance({
    baseURL: `${ENV_URLS.SERVICE_DIRECTROUTING_URL}/${ENV_URLS.API}/`,
    headers: { CustomerId: customerId, ProductCode: productCode },
    patch,
  })
export const externalHttpGENERICFUNCTIONALITYBaseSIP = (customerId, sipAddressId, patch) =>
  createApiInstance({
    baseURL: `${ENV_URLS.SERVICE_SIP_TRUNKING_URL}/${ENV_URLS.API}/`,
    headers: { CustomerId: customerId, sipAddressId },
    patch,
  })

export const externalHttpDIRECTROUTINGCreateBase = (customerId, productCode, patch) => {
  // createApiInstance({
  //   baseURL: `${ENV_URLS.SERVICE_DIRECTROUTING_URL}/${ENV_URLS.API}/`,
  //   headers: { CustomerId: customerId, ProductCode: productCode },
  //   patch,
  // })
  const config = {
    baseURL: [
      ENV_URLS.SERVICE_DIRECTROUTING_URL,
      ENV_URLS.API
    ].join("/") + "/",

    headers: {
      CustomerId: customerId,
      ProductCode: productCode
    }
  };

  // Only assign patch if provided
  if (patch) {
    config.patch = patch;
  }

  return createApiInstance(config);
};

export const externalHttpGENERICFUNCTIONALITYBase = (customerId, productCode, patch) =>
  createApiInstance({
    baseURL: `${ENV_URLS.SERVICE_GENERIC_FUNCTIONALITY_URL}/${ENV_URLS.API}/`,
    headers: { CustomerId: customerId, productCode },
    patch,
  })

export const externalHttpGENERICFUNCTIONALITYBaseForDelete = (customerId, header, patch) =>
  createApiInstance({
    baseURL: `${ENV_URLS.SERVICE_GENERIC_FUNCTIONALITY_URL}/${ENV_URLS.API}/`,
    headers: header,
    patch,
  })

export const externalHttpSIPAnywhereBase = (customerId, patch) =>
  createApiInstance({
    baseURL: `${ENV_URLS.SERVICE_SIP_TRUNKING_URL}/${ENV_URLS.API}/`,
    headers: { CustomerId: customerId },
    patch,
  })

export const externalAzureFunctionHttpTriggerBase = (functionURL, patch) =>
  createApiInstance({
    baseURL: functionURL,
    headers: {},
    patch,
  })

export const externalHttpCoreViewBaseWebPortalWithHeader = (header, patch, download) =>
  createApiInstance({
    baseURL: `${ENV_URLS.URL}/${ENV_URLS.API}/`,
    headers: header,
    patch,
    download
  })

export const externalHttpBaseGetApi = (header, patch, download) =>
  createApiInstance({
    baseURL: `${ENV_URLS.SERVICE_DIRECTROUTING_URL}/${ENV_URLS.API}/`,
    headers: header,
    patch,
    download
  })
